import { _mock } from "./_mock";

import {
  APPLICATION_STATUS_OPTIONS,
  APPLICATION_ITEM_STATUS_OPTIONS,
  APPLICATION_PAYMENT_STATUS_OPTIONS,
  APPLICATION_ITEM_PAYMENT_STATUS_OPTIONS,
  PAYMENT_METHODS,
} from "src/utils/applicationConstants";
import { BILLING_TYPES } from "src/utils/billingConstants";
import { addMinutesToDate } from "src/utils/format-time";
// ----------------------------------------------------------------------

const ITEMS = [...Array(10)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.productName(index),
  price: _mock.number.price(index),
  currency: "HUF",
  credit: Math.round(Math.random() * 10),
  type: Math.round(Math.random()) ? "reservation" : "waitinglist",
  venue: "3. pálya",
  date: "2024-11-23 00:30:00",
  start_time: "2024-11-23 12:30:00",
  end_time: "2024-11-23 14:30:00",
  payment_method: PAYMENT_METHODS[Math.floor(Math.random() * 3)].id,
  payment_status:
    APPLICATION_ITEM_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 2)],
  status: APPLICATION_ITEM_STATUS_OPTIONS[Math.floor(Math.random() * 3)].value,
}));

const itemsVariants = [
  [0, 5],
  [1, 7],
  [1, 2],
  [3, 5],
];

export const _applications = [...Array(20)].map((_, index) => {
  // const items =
  //   (index % 2 && ITEMS.slice(0, 1)) ||
  //   (index % 3 && ITEMS.slice(1, 3)) ||
  //   ITEMS;

  const deadlines = [
    addMinutesToDate(new Date(), 30),
    addMinutesToDate(new Date(), 40),
    addMinutesToDate(new Date(), 20),
    addMinutesToDate(new Date(), 12),
  ];

  const itemVariant = Math.floor(Math.random() * 4);

  const items = ITEMS.slice(
    itemsVariants[itemVariant][0],
    itemsVariants[itemVariant][1]
  );

  const credit = items.reduce(
    (accumulator, item) => accumulator + item.credit,
    0
  );

  const totalAmount = items.reduce(
    (accumulator, item) => accumulator + item.price,
    0
  );

  const customer = {
    id: _mock.id(index),
    name: _mock.fullName(index),
    email: _mock.email(index),
    avatarUrl: _mock.image.avatar(index),
    ipAddress: "192.158.1.38",
  };

  const billingInfos = {
    id: Math.floor(Math.random() * 1000),
    type: BILLING_TYPES[Math.round(Math.random())],
    first_name: _mock.firstName(index),
    last_name: _mock.lastName(index),
    country: _mock.companyName(index),
    address: _mock.fullAddress(index),
    city: _mock.tourName(index),
    zipcode: Math.round(Math.random() * 10000).toString(),
    taxnumber: _mock.taxNumber(index),
  };

  const history = [
    {
      id: Math.floor(Math.random() * 1000),
      transactionId: Math.floor(Math.random() * 1000),
      invoiceId: Math.floor(Math.random() * 1000),
      amount: Math.floor(Math.random() * 10000),
      currency: "HUF",
      remotePaymentId: _mock.id(index),
      remoteTransactionId: _mock.id(index),
      paymentStatus:
        APPLICATION_ITEM_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 2)],
      paymentMethodId: PAYMENT_METHODS[Math.floor(Math.random() * 3)].id,
      createdAt: _mock.time(index),
      modifiedAt: _mock.time(index),
      status: Math.round(Math.random()),
    },
    {
      id: Math.floor(Math.random() * 1000),
      transactionId: Math.floor(Math.random() * 1000),
      invoiceId: Math.floor(Math.random() * 1000),
      amount: Math.floor(Math.random() * 10000),
      currency: "HUF",
      remotePaymentId: _mock.id(index),
      remoteTransactionId: _mock.id(index),
      paymentStatus:
        APPLICATION_ITEM_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 2)],
      paymentMethodId: PAYMENT_METHODS[Math.floor(Math.random() * 3)].id,
      createdAt: _mock.time(index),
      modifiedAt: _mock.time(index),
      status: Math.round(Math.random()),
    },
    {
      id: Math.floor(Math.random() * 1000),
      transactionId: Math.floor(Math.random() * 1000),
      invoiceId: Math.floor(Math.random() * 1000),
      amount: Math.floor(Math.random() * 10000),
      currency: "HUF",
      remotePaymentId: _mock.id(index),
      remoteTransactionId: _mock.id(index),
      paymentStatus:
        APPLICATION_ITEM_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 2)],
      paymentMethodId: PAYMENT_METHODS[Math.floor(Math.random() * 3)].id,
      createdAt: _mock.time(index),
      modifiedAt: _mock.time(index),
      status: Math.round(Math.random()),
    },
  ];

  // const history = {
  //   orderTime: _mock.time(1),
  //   paymentTime: _mock.time(2),
  //   deliveryTime: _mock.time(3),
  //   completionTime: _mock.time(4),
  //   timeline: [
  //     { title: "Delivery successful", time: _mock.time(1) },
  //     { title: "Transporting to [2]", time: _mock.time(2) },
  //     { title: "Transporting to [1]", time: _mock.time(3) },
  //     {
  //       title: "The shipping unit has picked up the goods",
  //       time: _mock.time(4),
  //     },
  //     { title: "Order has been created", time: _mock.time(5) },
  //   ],
  // };

  return {
    id: _mock.id(index),
    orderNumber: `#601${index}`,
    createdAt: _mock.time(index),
    providerName: "Minta foci klub",
    providerAvatarurl: _mock.image.avatar(index),
    items,
    history,
    totalAmount,
    currency: "HUF",
    credit,
    customer,
    status: APPLICATION_STATUS_OPTIONS[Math.floor(Math.random() * 4)],
    deadline: deadlines[Math.floor(Math.random() * 4)],
    type:
      (index % 2 && "reservation") ||
      (index % 3 && "training") ||
      (index % 4 && "pass") ||
      (index % 5 && "ticket") ||
      "reservation",
    billingInfos,
    payment_status:
      APPLICATION_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 3)],
  };
});
